import { Map } from 'immutable';

import { FORM, FORM_TITLE } from './forms';
import { ETSY, SHOPIFY } from './channels';
import { EMPTY, VELA } from '.';
import { VARIANTS } from './variations';
import ATTRIBUTE from './attributes';

export const THUMBNAIL_SIZE = 42;

export const MAX_EDIT_HEIGHT_SIZE = '675px';

export const PROFILE = {
  LISTINGS: 'listings',
  TAGS: 'tags',
  SALES: 'sales',
  VARIATIONS: 'variations',
};

export const PROFILE_TYPE_NAME = {
  [PROFILE.LISTINGS]: 'Listings',
  [PROFILE.TAGS]: 'Tags',
  [PROFILE.SALES]: 'Sales',
  [PROFILE.VARIATIONS]: 'Variations',
};

export const PROFILES_TYPES = [
  PROFILE.LISTINGS,
  PROFILE.VARIATIONS,
  PROFILE.TAGS,
  PROFILE.SALES,
];

export const PROFILES_PER_PAGE = {
  [PROFILE.LISTINGS]: 10,
  [PROFILE.SALES]: 100,
  [PROFILE.TAGS]: 10,
  [PROFILE.VARIATIONS]: 10,
};

export const MAXIMUM_PROFILE_NAME_LENGTH = {
  [ETSY]: 140,
  [SHOPIFY]: 255,
  [VELA]: 255,
};

export const SALE_PROFILE_TITLE_OPERATION = {
  ADD_BEFORE: 'title.addBefore',
  ADD_AFTER: 'title.addAfter',
};

export const SALE_PROFILE_DESCRIPTION_OPERATION = {
  [ETSY]: {
    ADD_BEFORE: 'description.addBefore',
    ADD_AFTER: 'description.addAfter',
  },
  [SHOPIFY]: {
    ADD_BEFORE: 'body_html.addBefore',
    ADD_AFTER: 'body_html.addAfter',
  },
};

export const SALE_PROFILE_TAGS_OPERATION = {
  ADD: 'tags.add',
  REPLACE: 'tags.changeTo',
};

export const SALE_PROFILE_FILTER = {
  PENDING: 'pending',
  ACTIVE: 'active',
  COMPLETED: 'completed',
};

// V2

export const NEW_PROFILE_ERRORS = {
  [PROFILE.SALES]: Map({ [ATTRIBUTE.TAGS]: false, [ATTRIBUTE.PRICE]: true }),
  [PROFILE.TAGS]: Map({ [ATTRIBUTE.TAGS]: false }),
  [PROFILE.VARIATIONS]: Map({ [VARIANTS]: EMPTY.LIST }),
};

export const ALL = 'all';

export const PAGE_SIZE = 10;

export const CONNECTED_LISTINGS_LIMIT = 1000;

export const SAVE_TYPE = {
  UPDATE_PROFILE: 'Update current profile',
  SAVE_AS_NEW: 'Save as new profile',
};

export const SAVE_OPTIONS = [
  SAVE_TYPE.UPDATE_PROFILE,
  SAVE_TYPE.SAVE_AS_NEW,
];

export const PLACEHOLDERS = {
  SHOPS: 'Select shops',
  PROFILE_NAME: 'Enter Profile name',
};

export const FORM_LABEL = {
  [ALL]: 'All',
  ...FORM_TITLE,
};

export const FORMS = {
  [ETSY]: [
    FORM.PHOTOS,
    FORM.VIDEOS,
    FORM.TITLE,
    FORM.DESCRIPTION,
    FORM.TAGS,
    FORM.DETAILS,
    FORM.PRICING,
    FORM.INVENTORY,
    FORM.VARIATIONS,
    FORM.PERSONALIZATION,
    FORM.SHIPPING,
    FORM.FILES,
  ],
  [SHOPIFY]: [
    FORM.PHOTOS,
    FORM.VIDEOS,
    FORM.TITLE,
    FORM.DESCRIPTION,
    FORM.TAGS,
    FORM.DETAILS,
    FORM.PRICING,
    FORM.INVENTORY,
    FORM.VARIATIONS,
    FORM.SHIPPING,
    FORM.SEO,
  ],
};

export const ERRORS = {
  NAME: {
    ALPHANUMERIC_BEGIN: 'Profile name must begin with alphanumerical character',
    CAPITALIZED_WORDS_NUMBER_EXCEEDED: 'Profile name can contain at most three words with all capitalized letters',
    EMPTY: 'Fill in name',
    FORBIDDEN_CHARACTERS: 'Profile name can contain only alphanumeric and -+=/*%:& characters',
    NON_UNIQUE: 'Name must be unique',
    LENGTH_EXCEEDED: {
      [ETSY]: `Profile name should not exceed ${MAXIMUM_PROFILE_NAME_LENGTH[ETSY]} characters`,
      [SHOPIFY]: `Profile name should not exceed ${MAXIMUM_PROFILE_NAME_LENGTH[SHOPIFY]} characters`,
      [VELA]: `Profile name should not exceed ${MAXIMUM_PROFILE_NAME_LENGTH[VELA]} characters`,
    },
    SAME_NAME_PROFILE: 'You may not have two profiles with same name',
    SPECIAL_CHARACTERS_NUMBER_EXCEEDED: 'Profile name can contain characters % : & at most once',
  },
};
